/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Scalar for BigDecimal */
  BigDecimal: { input: number; output: number; }
  /** Scalar for BigInteger */
  BigInteger: { input: number; output: number; }
  /** Scalar for DateTime */
  DateTime: { input: string; output: string; }
};

export type AlreadyLoggedIn = {
  __typename: 'AlreadyLoggedIn';
  message?: Maybe<Scalars['String']['output']>;
};

/** Identifiziert einen Datev Zugang der Standortgruppe des angemeldeten Managers. */
export type DatevAccessKeyInput = {
  beraternummer: Scalars['String']['input'];
  lohnabrechnungsart: Lohnabrechnungsart;
  mandantennummer: Scalars['String']['input'];
};

export type DatevVerbindung = {
  __typename: 'DatevVerbindung';
  beraternummer: Scalars['String']['output'];
  lohnabrechnungsart: Lohnabrechnungsart;
  mandantennummer: Scalars['String']['output'];
  /** Danach muss sich die Standortgruppe erneut mit DATEV verbinden. (ISO-8601) */
  refreshTokenExpiresAt: Scalars['DateTime']['output'];
  /** Referenz auf die Verbindung, z.B. fuer starteMitarbeiterJob. */
  uid: Scalars['ID']['output'];
};

/** Die DATEV-Verbindung ist abgelaufen, die Standortgruppe muss sich erneut mit DATEV verbinden. */
export type DatevVerbindungExpired = {
  __typename: 'DatevVerbindungExpired';
  msg: Scalars['String']['output'];
};

export type Failure = AlreadyLoggedIn | GenericLoginFailure;

export type GenericLoginFailure = {
  __typename: 'GenericLoginFailure';
  message?: Maybe<Scalars['String']['output']>;
};

export type JobStatus =
  | 'IN_PROGRESS'
  | 'SUCCESS'
  | 'UNKNOWN';

export type LoginResult = LoginResultFailure | LoginResultSuccess;

export type LoginResultFailure = {
  __typename: 'LoginResultFailure';
  failure?: Maybe<Failure>;
};

export type LoginResultSuccess = {
  __typename: 'LoginResultSuccess';
  /** URL, zu der der Browser zum Login bei DATEV navigieren muss. */
  authorizationUrl?: Maybe<Scalars['String']['output']>;
  /** Bis dahin muss der Login bei DATEV abgeschlossen sein. (ISO-8601) */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Lohnabrechnungsart =
  | 'lodas'
  | 'lug';

/** Job bei DATEV, der die Mitarbeiter eines Datev Zugangs liefert. */
export type MitarbeiterJob = {
  __typename: 'MitarbeiterJob';
  beraternummer: Scalars['String']['output'];
  /** ISO-8601 */
  createdAt: Scalars['DateTime']['output'];
  /** Monat, für den die Mitarbeiter abgefragt werden, YYYY-MM. */
  jahrMonat: Scalars['String']['output'];
  lohnabrechnungsart: Lohnabrechnungsart;
  mandantennummer: Scalars['String']['output'];
  /** Status des Mitarbeiter Jobs. DATEV liefert in der Dokumentation nur 'accepted' (= inProgress) oder 'successful' (= success), jeder andere Wert gilt als abgeschlossen. */
  status: JobStatus;
  /** ISO-8601 */
  updatedAt: Scalars['DateTime']['output'];
};

/** Für den Datev Zugang läuft bereits ein Job, es wurde kein neuer angelegt. */
export type MitarbeiterJobAlreadyRunning = {
  __typename: 'MitarbeiterJobAlreadyRunning';
  mitarbeiterJob: MitarbeiterJob;
};

/** Mutation root */
export type Mutation = {
  __typename: 'Mutation';
  /** Startet den Login bei DATEV. Liefert die URL, zu der der Browser navigieren muss. */
  login: LoginResult;
  /** Legt bei DATEV einen Job an, der die Mitarbeiter des DATEV-Mandanten liefert. */
  starteMitarbeiterJob: StarteMitarbeiterJobResult;
};


/** Mutation root */
export type MutationLoginArgs = {
  input: DatevAccessKeyInput;
};


/** Mutation root */
export type MutationStarteMitarbeiterJobArgs = {
  input: StarteMitarbeiterJobInput;
};

/** Query root */
export type Query = {
  __typename: 'Query';
  /** Die bestehenden DATEV-Verbindungen der Standortgruppe des angemeldeten Managers. */
  datevVerbindungen?: Maybe<Array<Maybe<DatevVerbindung>>>;
  /** Der aktuelle bzw. letzte Mitarbeiter Job je Datev Zugang, in der Reihenfolge der Eingabe. null, wenn es zu dem Datev Zugang keinen Job gibt. */
  mitarbeiterJobs: Array<Maybe<MitarbeiterJob>>;
};


/** Query root */
export type QueryMitarbeiterJobsArgs = {
  input: Array<InputMaybe<DatevAccessKeyInput>>;
};

export type StarteMitarbeiterJobFailureResult = DatevVerbindungExpired | MitarbeiterJobAlreadyRunning;

export type StarteMitarbeiterJobInput = {
  /** Monat im Format YYYY-MM. Wenn null, wird der aktuelle Monat verwendet. */
  jahrMonat?: InputMaybe<Scalars['String']['input']>;
  /** Uid der DATEV-Verbindung, siehe datevVerbindungen. */
  uidDatevAccess: Scalars['String']['input'];
};

export type StarteMitarbeiterJobResult = StarteMitarbeiterJobResultFailure | StarteMitarbeiterJobResultSuccess;

export type StarteMitarbeiterJobResultFailure = {
  __typename: 'StarteMitarbeiterJobResultFailure';
  failure: StarteMitarbeiterJobFailureResult;
};

export type StarteMitarbeiterJobResultSuccess = {
  __typename: 'StarteMitarbeiterJobResultSuccess';
  mitarbeiterJob: MitarbeiterJob;
};

export type GetDatevVerbindungenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDatevVerbindungenQuery = { __typename: 'Query', datevVerbindungen?: Array<{ __typename: 'DatevVerbindung', uid: string, beraternummer: string, mandantennummer: string, lohnabrechnungsart: Lohnabrechnungsart, refreshTokenExpiresAt: string } | null> | null };

export type DatevLoginMutationVariables = Exact<{
  input: DatevAccessKeyInput;
}>;


export type DatevLoginMutation = { __typename: 'Mutation', login:
    | { __typename: 'LoginResultFailure', failure?:
        | { __typename: 'AlreadyLoggedIn', message?: string | null }
        | { __typename: 'GenericLoginFailure', message?: string | null }
       | null }
    | { __typename: 'LoginResultSuccess', authorizationUrl?: string | null, expiresAt?: string | null }
   };


export const GetDatevVerbindungenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDatevVerbindungen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datevVerbindungen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"beraternummer"}},{"kind":"Field","name":{"kind":"Name","value":"mandantennummer"}},{"kind":"Field","name":{"kind":"Name","value":"lohnabrechnungsart"}},{"kind":"Field","name":{"kind":"Name","value":"refreshTokenExpiresAt"}}]}}]}}]} as unknown as DocumentNode<GetDatevVerbindungenQuery, GetDatevVerbindungenQueryVariables>;
export const DatevLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"datevLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DatevAccessKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginResultSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginResultFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlreadyLoggedIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericLoginFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DatevLoginMutation, DatevLoginMutationVariables>;